import React from 'react';
import { Parameters } from '../../interfaces/PaymentForm';

export interface PaymentFormFieldSetProps {
    name: string;
    svg: string;
    parameters: Parameters[];
    url: string;
}

export const PaymentFormFieldSet = ({ name, svg, parameters, url }: PaymentFormFieldSetProps) => (
    <fieldset className="payment-fieldset" key={`payment-fieldset-${url}-${name}`}>
        {parameters.map(param => <input key={`payment-fieldset-${url}-${name}-${param.name}`} type="hidden" name={param.name} value={param.value} />)}
        <span>
            {svg && <img alt={name} src={svg} />}
        </span>
    </fieldset>
);
